import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IActivity } from 'app/shared/model/activity.model';
import { getEntity, updateEntity, createEntity, reset } from './activity.reducer';

export const ActivityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const activityEntity = useAppSelector(state => state.activity.entity);
  const loading = useAppSelector(state => state.activity.loading);
  const updating = useAppSelector(state => state.activity.updating);
  const updateSuccess = useAppSelector(state => state.activity.updateSuccess);

  const handleClose = () => {
    navigate('/activity');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.startDate = convertDateTimeToServer(values.startDate);
    values.createdAt = convertDateTimeToServer(values.createdAt);
    values.modifiedAt = convertDateTimeToServer(values.modifiedAt);

    const entity = {
      ...activityEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          startDate: displayDefaultDateTime(),
          createdAt: displayDefaultDateTime(),
          modifiedAt: displayDefaultDateTime(),
        }
      : {
          ...activityEntity,
          startDate: convertDateTimeFromServer(activityEntity.startDate),
          createdAt: convertDateTimeFromServer(activityEntity.createdAt),
          modifiedAt: convertDateTimeFromServer(activityEntity.modifiedAt),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="reachamyApp.activity.home.createOrEditLabel" data-cy="ActivityCreateUpdateHeading">
            <Translate contentKey="reachamyApp.activity.home.createOrEditLabel">Create or edit a Activity</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="activity-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('reachamyApp.activity.activityNumber')}
                id="activity-activityNumber"
                name="activityNumber"
                data-cy="activityNumber"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.categoryID')}
                id="activity-categoryID"
                name="categoryID"
                data-cy="categoryID"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.header')}
                id="activity-header"
                name="header"
                data-cy="header"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.details')}
                id="activity-details"
                name="details"
                data-cy="details"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.ageLimit')}
                id="activity-ageLimit"
                name="ageLimit"
                data-cy="ageLimit"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.planningForMicrofunding')}
                id="activity-planningForMicrofunding"
                name="planningForMicrofunding"
                data-cy="planningForMicrofunding"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.amountToRaise')}
                id="activity-amountToRaise"
                name="amountToRaise"
                data-cy="amountToRaise"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.postAsOrganisation')}
                id="activity-postAsOrganisation"
                name="postAsOrganisation"
                data-cy="postAsOrganisation"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.makeAsUrgentNeed')}
                id="activity-makeAsUrgentNeed"
                name="makeAsUrgentNeed"
                data-cy="makeAsUrgentNeed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.makeThisPrivateActivity')}
                id="activity-makeThisPrivateActivity"
                name="makeThisPrivateActivity"
                data-cy="makeThisPrivateActivity"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.startDate')}
                id="activity-startDate"
                name="startDate"
                data-cy="startDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.createdBy')}
                id="activity-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.createdAt')}
                id="activity-createdAt"
                name="createdAt"
                data-cy="createdAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.modifiedBy')}
                id="activity-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.activity.modifiedAt')}
                id="activity-modifiedAt"
                name="modifiedAt"
                data-cy="modifiedAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/activity" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ActivityUpdate;
